import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { IEntityState } from '@/store/stores/entity.store';
import { ITeam } from '@/types/Team';
import { IUser } from '@/types/User';
import { EnumPlans } from '@/enums/Plans';

export const getters: GetterTree<IEntityState, RootState> = {
  teams: (state: IEntityState): ITeam[] => {
    const usersWithTeams: IUser[] = state.users.filter((user: IUser) => !!user.team);
    const teams: ITeam[] = usersWithTeams.map((user: IUser) => user.team);
    const uniqueTeams: ITeam[] = [];
    for (const team of teams) {
      if (!uniqueTeams.some((t: ITeam) => t.id === team.id)) {
        uniqueTeams.push({
          ...team,
          users: usersWithTeams.filter((user: IUser) => user.team.id === team.id),
        });
      }
    }
    return uniqueTeams;
  },
  hasLimitedPlan: (state: IEntityState): boolean => {
    if (!state.planStatus) {
      return false;
    }
    return [EnumPlans.solo].includes(state.planStatus.plan);
  },
  hasCreditsLeft: (state: IEntityState): boolean => {
    if (!state.planStatus) {
      return true;
    }
    return state.planStatus.creditsLeft > 0;
  },
};
